import React, { useState } from 'react'

import DOMPurify from 'dompurify'

import { useIntl } from '@app/intl/Intl'
import { Chip } from '@app/lib/display/Chip/Chip'

import { Expandor } from '../Expandor'
import { IMessage, MessageType } from '../index'

import { MessageContentActions } from './MessageContentActions'
import './index.scss'

type Props = {
  deleteMessage?: (messageId: number) => void
  message: Partial<IMessage>
  collapsesLongText?: boolean
  onStartEdit?: React.MouseEventHandler
}

const MAXIMUM_UNCOLLAPSED_LENGTH_IN_CHARACTERS = 280

export const MessageContent = ({
  deleteMessage,
  message,
  collapsesLongText,
  onStartEdit
}: Props) => {
  const { formatMessage } = useIntl()
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpanded = () => setIsExpanded((prev) => !prev)

  const lineBreakToHTML = (str: string) => str.replace(/(?:\r\n|\r|\n)/g, '<br>')

  const isTooLong = message.content && message.content.length > 180
  const isCollapsable =
    collapsesLongText &&
    message.content &&
    message.content.length > MAXIMUM_UNCOLLAPSED_LENGTH_IN_CHARACTERS

  return (
    <div
      className={`
        modern-chat-message-content__wrapper
        ${onStartEdit ? 'modern-chat-message-content__wrapper--editable' : ''}
        ${
          message.type !== MessageType.Question
            ? 'modern-chat-message-content__wrapper--answer'
            : ''
        }
      `}
    >
      <MessageContentActions
        onStartEdit={onStartEdit}
        deleteMessage={deleteMessage}
        messageId={message.id}
      />
      <div
        className={`
          modern-chat-message-content__inner
          ${isCollapsable ? 'modern-chat-message-content__inner--collapsable' : ''}
          ${isExpanded ? 'modern-chat-message-content__inner--expanded' : ''}
          ${isTooLong ? 'modern-chat-message-editor__inner--tooLong' : ''}
        `}
      >
        {message.case?.origin && message.type === MessageType.Question && (
          <Chip variant='filled' size='sm' color='primary-gradient'>
            {formatMessage({
              id: 'Components.Lib.ModernChat.MessageContent.InnerContent.DigitalServices'
            })}
          </Chip>
        )}
        <div
          className='modern-chat-message-content__text'
          dangerouslySetInnerHTML={{
            __html:
              DOMPurify.sanitize(lineBreakToHTML(message.content ?? '')) ||
              'Beschreibe hier kurz Dein Problem und stelle Deine Fragen.'
          }}
        />
      </div>
      {isCollapsable && (
        <Expandor
          onExpand={toggleExpanded}
          answer={message.type !== MessageType.Question}
          expanded={isExpanded}
        />
      )}
    </div>
  )
}
